const fillInNames = (relatedProducts, allProducts) => {
  if (!relatedProducts
  || !relatedProducts.length
  ) return [];

  // The function is needed only for the start of the editing session,
  // When we have no names and these are filled from the products lists.
  // Once, editing continues, we will have everything we need, so we just
  // return the products as they are
  if (relatedProducts[0].label) return relatedProducts;

  const ids = relatedProducts.map(rel => rel.value);
  let productsWithNames = [];
  ids.forEach(id => {
    const theProd = allProducts.all.filter(prod => prod.id === id)[0];
    if (theProd) {
      productsWithNames.push({
        label: theProd.name,
        value: theProd.id,
      });
    }
  });
  return productsWithNames;
};

export default fillInNames;



// WEBPACK FOOTER //
// ./src/helpers/unileverSales/fillInNames.js